/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElInputNumber as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/input-number/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElRadioGroup as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { apiUsdkGlobalLoginConfEdit } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  __name: 'globalConf',
  props: {
    gid: {
      type: Number,
      required: true,
      default: 0
    },
    channel: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['ok'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const params = ref({});
    const type = ref('qkswitch');
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const count = ref(0);
    const countModel = ref(0);
    const handleChangeCount = val => {
      if (val != 0 && val != -1) {
        countModel.value = 1;
        count.value = val;
      } else {
        countModel.value = val;
        count.value = 0;
      }
    };
    const title = computed(() => {
      const cname = props.channel.name;
      if (type.value === 'qkswitch') {
        return `${cname}渠道 登录界面显示`;
      } else if (type.value === 'showbind') {
        return `${cname}渠道 游客登录绑定提醒`;
      } else if (type.value === 'paybind') {
        return `${cname}渠道 游客支付绑定提醒`;
      }
    });
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const emits = __emit;
    const handleSubmit = async () => {
      let data = JSON.stringify([params.value]);
      confirmLoading.value = true;
      console.log('data--');
      console.log(data);
      const res = await apiUsdkGlobalLoginConfEdit({
        gid: props.gid,
        cid: props.channel.cid,
        data
      });
      confirmLoading.value = false;
      if (res.code === 0) {
        emits('ok');
        handleClose();
      }
    };
    const show = (_type, _params) => {
      type.value = _type;
      params.value = {
        ..._params
      };
      params.value.val = Number(_params.val);
      if (type.value === 'showbind') {
        handleChangeCount(_params.val);
      }
      dialogVisible.value = true;
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_radio = __unplugin_components_0;
      const _component_el_radio_group = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_input_number = __unplugin_components_3;
      const _component_el_form = __unplugin_components_4;
      const _component_el_button = __unplugin_components_5;
      const _component_el_dialog = __unplugin_components_6;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: _unref(title),
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(confirmLoading),
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, null, {
          default: _withCtx(() => [_unref(type) === 'qkswitch' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "登录界面"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(params).val,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(params).val = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 0
              }, {
                default: _withCtx(() => [_createTextVNode("无界面")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("有界面")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _unref(type) === 'showbind' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "登录提醒"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(params).val,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(params).val = $event),
              onChange: handleChangeCount
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: -1
              }, {
                default: _withCtx(() => [_createTextVNode("不提醒")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 0
              }, {
                default: _withCtx(() => [_createTextVNode("每次提醒")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("间隔 "), _createVNode(_component_el_input_number, {
                  modelValue: _unref(params).memo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(params).memo = $event),
                  modelModifiers: {
                    number: true
                  },
                  min: 1
                }, null, 8, ["modelValue"]), _createTextVNode(" 次提醒")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _unref(type) === 'paybind' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "登录提醒"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(params).val,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(params).val = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 0
              }, {
                default: _withCtx(() => [_createTextVNode("不提醒")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("每次提醒")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
});